<template>

<div>

  <LDBsTable
    url="ostests"
    defaultSort="id"
    defaultOrder="desc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="os_number">{{ $t('os_number') }}</label>
      <input
        type="text"
        id="os_number"
        name="os_number"
        class="form-control"
        :placeholder="$t('ph_os_number')"
        v-model="query.number"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
      <vue-select
        :select-on-tab='true'
        class="bg-white"
        name='garage_accredited'
        :placeholder="$t('select_a_item')"
        label='fantasyName'
        :options="garages.rows"
        v-model="query.garageAccredited"
        :reduce="garageId => garageId.id"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="serial">{{ $t('new_equipment') }}</label>
      <input
        type="text"
        id="serial"
        name="serial"
        class="form-control"
        :placeholder="$t('ph_new_equipment')"
        v-model="query.serial"
      >
    </div>

    <div class="form-group col-lg-8">
      <label for="contract">{{ $t('contract') }}</label>
      <vue-select
        :select-on-tab='true'
        class="bg-white"
        name='contract'
        :placeholder="$t('select_a_item')"
        label="contracts"
        :options="oss.contracts"
        v-model="query.contract"
        :reduce='contract => contract.id_contrato'
        v-validate="'required'"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        id="board"
        name="board"
        class="form-control"
        :placeholder="$t('ph_board')"
        v-model="query.board"
      >
    </div>

    <div class="form-group col-lg-4">
      <label for="services">{{ $t('services') }}</label>
      <vue-select
        :select-on-tab='true'
        class="bg-white"
        name='services'
        :placeholder="$t('select_a_item')"
        label='name'
        :options="oss.serviceTypes"
        :reduce='serviceType => serviceType.id'
        v-model="query.services"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="reason">{{ $t('reason') }}</label>
      <vue-select
        :select-on-tab='true'
        class="bg-white"
        name='reason'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="oss.maintanceReasons"
        v-model="query.maintanceReason"
        :reduce="maintanceReason => maintanceReason.id"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="withdrawnSerial">{{ $t('old_equipment') }}</label>
      <input
        type="text"
        id="withdrawnSerial"
        name="withdrawnSerial"
        class="form-control"
        :placeholder="$t('ph_old_equipment')"
        v-model="query.withdrawnSerial"
      >
    </div>
  </LDBsTable>

  <!-- MODAL OPEN OS -->
  <div class="modal fade" id="modalOpenOs" tabindex="-1" role="dialog" aria-labelledby="titleModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="titleModal">Abrir OS</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="text-center">
            <b-spinner v-show="loading" />
          </div>

          <div class="form-group" v-if="!loading">
            <label for="new_equipment">{{ $t('new_equipment') }}</label>
            <Combobox
              class="bg-white"
              name='new_equipment'
              :placeholder="$t('select_a_item')"
              :hasErrors="errors.has('new_equipment')"
              :options="serials"
              :initial-value="os.serial"
              v-model="os.serial"
              v-validate="`required`"
            />

            <small v-show="errors.has('new_equipment')" class="form-text text-muted">
              {{ errors.first('new_equipment') }}
            </small>
          </div>

          <div class="form-group" v-if="!loading">
            <label for="services">{{ $t('services') }}</label>
            <Combobox
              class="bg-white"
              name='services'
              :placeholder="$t('select_a_item')"
              :hasErrors="errors.has('services')"
              label='name'
              :options="[{ name: 'Instalação', id: 1 }, { name: 'Manutenção', id: 2 }, { name: 'Reinstalação', id: 6 }]"
              :reduce="serviceType => serviceType.id"
              :initial-value="os.services"
              v-model="os.services"
              v-validate="'required'"
            />

            <small v-show="errors.has('services')" class="form-text text-muted">
              {{ errors.first('services') }}
            </small>
          </div>
        </div>

        <div class="modal-footer">
          <button
            :disabled="loading"
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            {{ $t('close') }}
          </button>

          <button
            :disabled="loading"
            type="button"
            class="btn btn-primary btn-form"
            @click="save"
          >
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
  </div>

</div>

</template>

<script>
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import { request } from '@/lib/http'
import _ from 'lodash'

export default {
  name: 'OsTests',
  components: {
    LDBsTable,
    Combobox
  },

  data () {
    return {
      columns: [
        {
          title: this.$t('os'),
          field: 'id',
          width: '50%',
          sortable: true
        },
        {
          title: this.$t('status'),
          field: 'status',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('garage_accredited'),
          field: 'garageAccredited',
          formatter: function(value) {
            if (!value) {
              return '-'
            }

            const info = [value.fantasyName]

            const city = _.get(value, 'city', '')
            const uf = _.get(value, 'uf', '')

            city && info.push(city.toUpperCase())
            uf && info.push(uf.toUpperCase())

            return info.join(' - ')
          },
          sortable: true
        },
        {
          title: this.$t('new_equipment'),
          field: 'serial',
          sortable: true
        },
        {
          title: this.$t('old_equipment'),
          field: 'withdrawnSerial',
          sortable: true
        },
        {
          title: this.$t('contract'),
          field: 'contract',
          formatter: function(value) {
            return value.contracts
          },
          sortable: true
        },
        {
          title: this.$t('board'),
          field: 'board',
          sortable: true,
          formatter: value => {
            return value.length === 7
              ? value.substr(0,3)+"-"+value.substr(3,7)
              : value
          }
        },
        {
          title: this.$t('vehicle_type'),
          field: 'vehicleType',
          formatter: function(value) {
            return value.TPV_DSC
          },
          visible: false,
          sortable: true
        },
        {
          title: this.$t('services'),
          field: 'services',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('reason'),
          field: 'maintanceReason',
          formatter: function(value) {
            return value
              ? value.name
              : '-'
          },
          visible: false,
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/ostests/test/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-tasks"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'OS_TESTES' }
      },
      query: {
        id: '',
        number: '',
        garageAccredited: '',
        serial: '',
        withdrawnSerial: undefined,
        contract: '',
        board: '',
        services: '',
        maintanceReason: ''
      },
      os: {
        serial          : '',
        services        : undefined,
        requireSerial   : true,
        garageAccredited: undefined
      },
      serials: [],
      loading: false
    }
  },

  computed: {
    ...mapState({
      garages: state => state.garageaccredited.all,
      oss    : state => state.os.all
    })
  },

  methods: {
    clear() {
      this.query.number = undefined,
      this.query.garageAccredited = undefined,
      this.query.serial = '',
      this.query.withdrawnSerial = undefined,
      this.query.contract = '',
      this.query.board = '',
      this.query.vehicleType = '',
      this.query.services = '',
      this.query.maintanceReason = ''
    },

    async save() {
      this.loading = true

      await this.$store.dispatch('os/create', { ...this.os })

      $('#modalOpenOs').modal('hide')

      this.loading = false

      $('#search').trigger('click')
    }
  },

  async mounted () {
    const { dispatch } = this.$store

    dispatch('overlay/show', true)

    await dispatch('os/fetchAllPageOsList')
    await dispatch('garageaccredited/fetchFiltered', { user: true })

    dispatch('overlay/show', false)

    const global = this
    $('#modalOpenOs').on('show.bs.modal', async function (event) {
      global.loading = true

      try {
        const { serials, garageAccredited } = await request({
          url: 'get-serials-garage',
          method: 'get'
        })

        global.serials          = serials.map(active => active.serie)
        global.os.garageAccredited = garageAccredited
      } catch (error) {
        setTimeout(() => {
          $('#modalOpenOs').modal('hide')
          dispatch('notify/error', { message: error.message })
        }, 500)
      } finally {
        global.loading = false
      }
    })

    $('#modalOpenOs').on('show.bs.modal', async function (event) {
      global.os.serial   = ''
      global.os.services = undefined
    })
  },

  destroyed () {
    const { dispatch } = this.$store

    dispatch('maintancereason/cleanState'),
    dispatch('contracts/cleanState'),
    dispatch('vehicletypes/cleanState'),
    dispatch('garageaccredited/cleanState'),
    dispatch('servicetypes/cleanState')
  }
}
</script>
